import constants from '@core/utils/constants';
import { bus } from '@core/events/eventSystem';
import { serializer } from './serializer';
import { getStore } from '@core/store';

bus.on(constants.EVENTS.WALLET.REFRESH, (data) => {
  if (!data.userId) return;
  const userId = data.userId
  const requestId = `waallet-${Date.now()}`;

  let url = `${constants.ENDPOINTS.WALLET.GET}`;
  url = url.replace('{userId}', userId);

  bus.emit(EVENTS.WALLET.REFRESHING, { userId });
  bus.emit(constants.EVENTS.NETWORK.REQUEST, {
    id: requestId,
    url,
    method: 'GET',
    data: {}
  });

  bus.on(constants.EVENTS.NETWORK.RESPONSE, (res) => {
    if (res.id === requestId) {
      const parsed = serializer.deserialize(res);
      if (parsed.success) {
        parsed.data.userId = userId;
        bus.emit(EVENTS.WALLET.REFRESHED, parsed.data);
      } else {
        bus.emit(EVENTS.WALLET.REFRESH_ERROR, { userId, error: parsed });
      }
    }
  });
});

bus.on(constants.EVENTS.WITHDRAW.REQUEST, (data) => {
  const { amount, phoneNumber, network } = data;
  const userStore = getStore('user');
  const userId = userStore.state.current?.id;
  if (!userId) return;

  const requestId = `withdraw-${Date.now()}`;
  let url = constants.ENDPOINTS.WALLET.WITHDRAW.replace('{userId}', userId);

  bus.emit(constants.EVENTS.WITHDRAW.PROCESSING);
  bus.emit(constants.EVENTS.NETWORK.REQUEST, {
    id: requestId,
    url,
    method: 'POST',
    data: { amount, phoneNumber, network, accountType: 'channelManagement' }
  });

  const handler = (res) => {
    if (res.id === requestId) {
      bus.off(constants.EVENTS.NETWORK.RESPONSE, handler);
      const isSuccess = (res.status >= 200 && res.status < 300) || res.data?.success;
      if (isSuccess && !res.error) {
        bus.emit(constants.EVENTS.WITHDRAW.SUCCESS, res.data?.data || res.data);
        // Refresh balance after success
        bus.emit(constants.EVENTS.WALLET.REFRESH, { userId });
      } else {
        const errorMsg = res.error?.error?.message || res.data?.error?.message || res.error?.message || res.error || 'Erreur lors du retrait';
        bus.emit(constants.EVENTS.WITHDRAW.ERROR, errorMsg);
      }
    }
  };
  bus.on(constants.EVENTS.NETWORK.RESPONSE, handler);
});
